import { Component } from '@angular/core';
import { Origin } from '@vendasta/sales-orders';
import { Option, StaticStringSelectComponent } from '../static-string-select/static-string-select.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

export const OrderOriginOptions: Option[] = [
  {
    value: '' + Origin.PC,
    label: 'AUTOMATIONS.EDITOR.TRIGGERS.ORDER_STATUS_CHANGED.ORIGIN_OPTIONS.PC',
  },
  {
    value: '' + Origin.SSC,
    label: 'AUTOMATIONS.EDITOR.TRIGGERS.ORDER_STATUS_CHANGED.ORIGIN_OPTIONS.SSC',
  },
  {
    value: '' + Origin.VBC,
    label: 'AUTOMATIONS.EDITOR.TRIGGERS.ORDER_STATUS_CHANGED.ORIGIN_OPTIONS.BUSINESS_APP',
  },
];

@Component({
  selector: 'automata-order-origin-options',
  templateUrl: '../static-string-select/static-string-select.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
  ],
})
export class OrderOriginOptionsComponent extends StaticStringSelectComponent {
  options: Option[] = OrderOriginOptions;
  label = 'AUTOMATIONS.EDITOR.FILTERS.ORDER_DATA.DATA_LABELS.ORIGIN';
  required = true;
}
